import styled from 'styled-components';

export const TwilioLifeIdVideoSC = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(000, 000, 000, 0) 0%,
    rgba(000, 000, 000, 0.5) 51.04%,
    #000 100%
  );

  .empty-participant {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 270px;
    height: 205px;
    border-radius: 30px;
    z-index: 99997;
    border: 1px solid #ffffff;
    background: black;
    &.draggable {
      top: 10px;
      right: 10px;
      width: 80px;
      height: 100px;
      border-radius: 15px;
    }
    @media only screen and (max-width: 1366px) {
      top: 20px;
      right: 20px;
      width: 240px;
      height: 180px;
    }
  }
`;
